export const isStaging = () =>
  process.env.NODE_ENV !== 'production' ||
  (typeof window !== 'undefined' &&
    (window.location.hostname.endsWith('.staging.daily.co') ||
      window.location.hostname.endsWith('.now.sh') ||
      window.location.hostname.endsWith('.vercel.app')));
